import classNames from 'classnames';
import { HTMLRenderer } from 'common/html-renderer.js';
import { ImageWrapper } from 'common/image/image-wrapper.js';
import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';
import { parse } from 'date-fns/parse';
import { DATE_FORMATS, formatDate } from 'utilities/date.js';
import { AllowedTags } from 'utilities/text/sanitizeHTML.js';

export interface IArticleItem {
  date: string;
  title: string;
  byLine: string;
  image?: string;
  url: string;
}

interface IArticleProps {
  items: Array<IArticleItem>;
}

export const ArticleList = ({ items }: IArticleProps) => {
  const renderArticles = (items: Array<IArticleItem>) =>
    items.map((item, index) => {
      const { date, title, byLine, url, image } = item;

      const parsed = parse(date, DATE_FORMATS.DateParse, new Date());
      const formattedDate = formatDate(
        !parsed || parsed.toString() === 'Invalid Date' ? date : parsed,
        DATE_FORMATS.DateDateMonth,
      );

      return (
        <li className="ArticleList-item warning-panel" key={index}>
          <LinkFactoryReactRouter href={url} className="u-width1of1 u-block u-linkClean">
            <div className="Grid Grid--withGutter">
              {image && (
                <div className="Grid-cell u-md-width1of3">
                  <ImageWrapper src={image} ratio="16:9" rounded shadow />
                </div>
              )}
              <div className={classNames('Grid-cell', { 'u-md-width1of1': !image, 'u-md-width2of3': image })}>
                {formattedDate && <h4 className="u-md-mT-0 u-mB-xs u-textDefault">{formattedDate}</h4>}

                <HTMLRenderer
                  content={title}
                  classes={'u-mT-0 u-mB-xs u-textBold u-textDefault'}
                  tags={AllowedTags.IFramePrevent}
                />

                <HTMLRenderer
                  content={byLine}
                  classes={'u-mT-0 u-mB-0 fineprint u-textGrey'}
                  tags={AllowedTags.IFramePrevent}
                />
              </div>
            </div>
          </LinkFactoryReactRouter>
        </li>
      );
    });

  return (
    <ul className="ArticleList" data-module-name="article-list">
      {renderArticles(items)}
    </ul>
  );
};
